import { Controller } from '@hotwired/stimulus'

const UPDATE_DELAY_MS = 200

export default class NotificationCountController extends Controller {
  connect() {
    this.handleBeforeStreamRender = this.beforeStreamRender.bind(this)
    document.addEventListener(
      'turbo:before-stream-render',
      this.handleBeforeStreamRender
    )
  }

  disconnect() {
    clearTimeout(this.renderTimer)
    document.removeEventListener(
      'turbo:before-stream-render',
      this.handleBeforeStreamRender
    )
  }

  beforeStreamRender(event) {
    const stream = event.target

    if (stream.getAttribute('target') !== this.element.id) return

    event.preventDefault()
    clearTimeout(this.renderTimer)

    const pendingStream = stream.cloneNode(true)
    const render = event.detail.render

    stream.remove()

    this.renderTimer = setTimeout(() => {
      render(pendingStream)
    }, UPDATE_DELAY_MS)
  }
}
